module.exports = __webpack_public_path__ + "static/media/IQ.4bdb6c53.PNG";